import React, {Component} from 'react'
import { modes } from 'utils/redux/config/modes'
import Form from 'components/form/Form'
import { Field } from 'redux-form'
import InputField from 'components/form/InputField'
import CustomSelectField from 'components/form/CustomSelectField'
import CurrencyOption from 'components/form/CurrencyOption'
import CurrencySingleValue from 'components/form/CurrencySingleValue'
import Button from 'components/Button'
import PropTypes from 'prop-types'

class Calculator extends Component {

	componentWillMount() {
		this.props.resetCalculator()
	}

	render () {
		const { selectedMode, from, to, total, switchCurrencies } = this.props

		const modeSettings = modes[selectedMode]
		return <Form className='o-layout o-layout--center u-margin-bottom-huge u-margin-top-large u-margin-top-none@desktop' {...this.props}>
			<div className='o-layout__item u-1/4@desktop u-1/1'>
				<div className='c-calculator__field c-calculator__field--left'>
					<Field
						name='fromQuantity'
						type='number'
						component={InputField}
						min={0}
						className='c-input c-input--left'
					/>
					<Field
						className='c-select--left'
						name='fromCurrency'
						placeholder='Избери'
						component={CustomSelectField}
						optionComponent={CurrencyOption}
						SingleValue={ props => <CurrencySingleValue position='left' {...props}/>}
						options={from.map(c => ({
							value: c.id,
							name: c.name,
							abbreviature: c.abbreviature,
							flag: c.flag,
							isCrypto: c.is_crypto
						}))}
					/>
				</div>
			</div>
			<div className='o-layout__item u-margin-top-small@desktop u-margin-top u-1/6@desktop u-1/1'>
				<Button className={`c-calculator__btn c-calculator__btn--${modeSettings.oppositeColor}`} onClick={switchCurrencies}>
					<span className='c-icon c-icon--exchange'></span>
				</Button>
			</div>
			<div className='o-layout__item u-1/4@desktop u-1/1'>
				<div className='c-calculator__field c-calculator__field--right'>
					<div className='c-result c-result--right u-text--large'>{total}</div>
					<Field
						className='c-select--right'
						name='toCurrency'
						placeholder='Избери'
						component={CustomSelectField}
						optionComponent={CurrencyOption}
						SingleValue={ props => <CurrencySingleValue position='right' {...props}/>}
						options={to.map(c => ({
							value: c.id,
							name: c.name,
							abbreviature: c.abbreviature,
							flag: c.flag,
							isCrypto: c.is_crypto
						}))}
					/>
				</div>
			</div>
		</Form>
	}
}

Calculator.propTypes = {
	selectedMode: PropTypes.string,
	from: PropTypes.array,
	to: PropTypes.array,
	total: PropTypes.string,
	switchCurrencies: PropTypes.func
}

export default Calculator
